<template>
    <div>
        <div class="popup popup--visible">
            <div :class="'popup__content popup__content--'+rezise">
                <div class="d-flex justify-content-center">
                    <div class="popup__loader">{{`${message || 'Cargando...'}`}}</div>
                   <mdb-spinner big multicolor />

                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import { mdbSpinner } from 'mdbvue';

    export default {
        name: "Loader",
        components: {
            mdbSpinner
        },
        props: ['message', 'size'],
        data(){
            return {
                open: false
            }
        },
        computed: {
            visible(){
                return this.open ? ' popup--visible' : '';
            },
            rezise(){
                if(this.size){
                    return this.size
                }
                else{
                    return "xxs"
                }

            }
        },
        methods: {
            toggleModal(){
                this.open = !this.open;
            }
        }
    }
</script>